import { bootstrapApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';

import { appConfig } from './app/app.config';

import { JobToJobListComponent } from './app/Modules/Job/Components/job-to-joblist-widget/job-to-joblist-widget.component';
import { JobDescriptionModelPOPUPComponent } from './app/Modules/Job/Components/job-description-model-popup/job-description-model-popup.component';
import { ResumeGenerateComponent } from './app/Modules/Profile/Components/resume-generate/resume-generate.component';
import { PowerSearchComponent } from './app/Modules/Search/Components/power-search/power-search.component';
import { JobsMapComponent } from './app/Modules/Job/Components/jobs-map/jobs-map.component';
import { PageHeaderComponent } from 'app/page-header/page-header.component';
import { DialogComponent } from 'app/Modules/Common/Components/dialog/dialog.component';
import { BrModalComponent } from '@brassring-ics/br-ui-wrapper';
import { CommonWarepperDialogueComponent } from './app/Modules/Common/Components/common-warepper-dialogue/common-warepper-dialogue.component';

import { ResumeConsentWorkflowService } from './app/Modules/Profile/Services/resume-consent-workflow.service';
import { firstValueFrom } from 'rxjs';
import { PartialApplyComponent } from './app/Modules/Job/Components/partial-apply/partial-apply.component';
import { JobDetailsComponent } from 'app/Modules/Job/Components/job-details/job-details.component';

bootstrapApplication(JobToJobListComponent, appConfig)
  .then(appRef => {

    const injector = appRef.injector;

    customElements.define(
      'job-description-model-popup',
      createCustomElement(JobDescriptionModelPOPUPComponent, { injector })
    );

    customElements.define(
      'app-resume-generate',
      createCustomElement(ResumeGenerateComponent, { injector })
    );

    customElements.define(
      'app-powersearch',
      createCustomElement(PowerSearchComponent, { injector })
    );

    customElements.define(
      'app-page-header',
      createCustomElement(PageHeaderComponent, { injector })
    );

    customElements.define(
      'job-job-list',
      createCustomElement(JobToJobListComponent, { injector })
    );

    customElements.define(
      'app-jobs-map',
      createCustomElement(JobsMapComponent, { injector })
    );

    customElements.define(
      'br-modal',
      createCustomElement(BrModalComponent, { injector })
    );

    customElements.define(
      'app-common-warepper-dialogue',
      createCustomElement(CommonWarepperDialogueComponent, { injector })
    );
    customElements.define('job-details', createCustomElement(JobDetailsComponent, { injector }));

    // =========================================================
    // RESUME WORKFLOW BRIDGE
    // =========================================================

    const workflowService =
      injector.get(ResumeConsentWorkflowService);

    (window as any).ngResumeWorkflow = {

      start: (jobId?: string | number, pageType?: string) =>
        workflowService.start(jobId != null ? Number(jobId) : undefined, pageType)

    };

  })
  .catch(err =>
    console.error(
      '[Bootstrap] Error during bootstrap:',
      err
    )
  );
